module.exports = __webpack_public_path__ + "static/media/hot-noodles-ad4.e3aa0c88.png";